import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { jwtDecode } from "jwt-decode";
import { reactComment, unReactPost } from "../../api/reactComment";
import useGetPostCommentsById from "../../hooks/useGetPostCommentsById";
import ReactionCommentButton from "../reactionCommentButton/ReactionCommentButton";
import {
  TokenPayload,
  CommentReactionProps,
  PostUserProps,
} from "../../types/ComponentProps";

const ReactionComment = ({ data }: CommentReactionProps) => {
  const queryClient = useQueryClient();
  const { refetch } = useGetPostCommentsById(data?.postId as number);
  const [reactLoading, setReactLoading] = useState<boolean>(false);

  const token = localStorage.getItem("accessTokenGC");
  const userDetails: TokenPayload = jwtDecode(token || "");

  const isReacted = data?.reactions?.some((user: PostUserProps) => {
    return Number(user?.id) === Number(userDetails?.id);
  });

  const reactCommentMutation = useMutation({
    mutationFn: reactComment,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["getPostComments", data?.commentId],
      });
      await refetch();
    },
    onError: (error: Error) => {
      console.error("Error liking comment:", error.message);
    },
  });

  const unReactCommentMutation = useMutation({
    mutationFn: unReactPost,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["getPostComments", data?.commentId],
      });
      await refetch();
    },
    onError: (error: Error) => {
      console.error("Error unliking comment:", error.message);
    },
  });

  const onReactionButtonClickHandler = async (index: number) => {
    setReactLoading(true);
    try {
      if (!isReacted) {
        await reactCommentMutation.mutateAsync({
          post: data,
          index,
        });
      } else {
        await unReactCommentMutation.mutateAsync({ post: data, index });
      }
    } catch (error) {
      console.error("Error during like/unlike mutation:", error);
    } finally {
      setReactLoading(false);
    }
  };

  return (
    <ReactionCommentButton
      onLikeButtonClickHandler={onReactionButtonClickHandler}
      post={data}
      likeIsLoading={reactLoading}
      isLiked={isReacted}
      userDetails={userDetails}
    />
  );
};

export default ReactionComment;
